import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "@/pages/trust/TrustPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/about")({
  head: () =>
    seoHead({
      title: "About: Founder & Psychologist-Designed Courses",
      description: "LeadXkids: psychologist-designed, story-based behavioural and life-skills courses for kids 8-14 in India, founded by Anvith Murthy, Bengaluru.",
      canonical: "/about",
      pageType: "AboutPage",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", url: "/" },
          { name: "About", url: "/about" },
        ]),
      ],
    }),
  component: AboutPage,
});
